module.exports = (v) => typeof v === 'function';
